import styled from 'styled-components';

/* ----------------------------------
   Custom training
----------------------------------- */

export const CustomTrainingSection = styled.section`
  width: 100%;

  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(280px, 0.8fr);
  gap: var(--space-xxxl);

  align-items: center;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: var(--space-xl);
  }
`;

export const CustomTrainingContent = styled.div`
  h2 {
    margin: var(--space-xs) 0 var(--space-m);

    color: var(--grey7);

    font-size: clamp(2rem, 3.5vw, 3rem);
    line-height: 1.05;
  }

  > p:not(.eyebrowHeader) {
    max-width: 700px;

    margin: 0;

    color: var(--grey4);

    font-size: 1rem;
    line-height: 1.8;
  }
`;

export const InlineLinks = styled.div`
  margin-top: var(--space-xl);

  display: flex;
  flex-wrap: wrap;
  gap: var(--space-l);

  @media screen and (max-width: 500px) {
    flex-direction: column;
    gap: var(--space-m);
  }
`;

export const TextLink = styled.a`
  width: fit-content;

  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);

  color: var(--grey7);

  font-size: 0.9rem;
  font-weight: 900;

  text-decoration: none;

  span {
    color: var(--orange5);
    transition: transform 0.2s ease;
  }

  &:hover {
    color: var(--orange5);

    span {
      transform: translateX(4px);
    }
  }
`;

export const CustomTrainingPoints = styled.div`
  border-top: 1px solid var(--grey);
`;

export const CustomPoint = styled.div`
  padding: var(--space-l) 0;

  display: grid;
  grid-template-columns: 45px minmax(0, 1fr);
  gap: var(--space-m);

  align-items: center;

  border-bottom: 1px solid var(--grey);

  span {
    color: var(--orange5);

    font-size: 0.75rem;
    font-weight: 700;
  }

  p {
    margin: 0;

    color: var(--grey6);

    font-size: 0.92rem;
    font-weight: 800;
  }
`;
